import * as React from 'react';
import * as Redux from 'redux';
import ReactSVG from 'react-svg';
import WKT from 'ol/format/wkt';
import OlExtent from 'ol/extent';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { translate } from "react-i18next";
import loading from './../../../utilities/loading';
import messageManager from './../../../utilities/messageManager';
import CommentCreator from './CommentCreator';
import { modalInstance } from './../Content';
import TextInput from './../../../components/TextInput';
import DefaultButton from './../../../components/DefaultButton';
import Spinner from './../../../components/Spinner';
import IconCancel from './../../../icons/cancel.svg';
import IconEdit from './../../../icons/edit.svg';
import IconDelete from './../../../icons/delete.svg';
import {
    getComments,
    getCommentsSuccess,
    selectComment,
} from './../../../actions/comments';
import {
    centerMap, 
    setEditMode,
} from './../../../actions/map';

const StyledWrapper = styled.div`
  overflow: auto;
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
`;

const ListRow = styled.div`
    width: calc(100% - 10px);
    background-color: #ffffff;
    border-radius: 5px;
    margin: 5px;

    input[type='radio'] {
        display: none;
    }
    label {
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        :hover {
            .rowTitle{
                border: 1px solid #a7c1d7;
                padding: 6.5px;
            }
        }
        .rowTitle {
            cursor: pointer;
            border: 1px solid #ebebeb;
            border-radius: 5px;
            padding: 6.5px;
            >span{
                margin-top: 5px;
                font-size: 14px;
                font-weight: 600;
                display: flex;
                justify-content: flex-end;
            }
        }
    }
    input[type='radio']:checked+label>.rowTitle {
        border: 1.5px solid ${props => props.borderColor || '#265a9c'};
        box-shadow: 0 1px 3px rgba(0,0,0, 0.3);
        padding: 6px;
    }
`;

class CommentsManager extends React.Component {
    constructor() {
        super();
        this.state = {
            filterTerm: '',
            commentCreatorVisible: false,
            deleteButtonDisabled: false,
            editMode: false,
        }
    }

    customizeModalWindow() {
        const { t, selectedComment } = this.props
        const confirmCallback = () => {
            this.deleteComment(selectedComment.id)
        }
        const config = {
            title: t('Do you really want to delete that comment') + '?',
            content: <p>{t('Do you really want to delete that comment')}?</p>,
            confirmCallback: confirmCallback,
            cancelBtnVisible: true,
            confirmBtnVisible: true,
            confirmBtnText: t('Delete'),
            closeOnConfirm: true,
            type: 'warning',
        };
        modalInstance.customize(config);
    }

    deleteComment(selectedCommentId) {
        const { BASE_URL, axiosInstance, comments, t, getCommentsSuccess } = this.props;
        loading.start();
        this.setState({ deleteButtonDisabled: true });
        axiosInstance.delete(`${BASE_URL}comments/${selectedCommentId}`)
            .then(response => {
                getCommentsSuccess(comments.filter(comment => Number(comment.id) !== Number(selectedCommentId)));
                this.setState({ deleteButtonDisabled: false });
                loading.stop();
                messageManager.show({
                    text: t('Comment deleted'),
                    type: 'info',
                })
            })
            .catch((error) => {
                loading.stop();
                this.setState({ deleteButtonDisabled: false });
                messageManager.show({
                    text: t(error.response.data),
                    type: 'error',
                })
            })
    }

    hideCommentCreator() { this.setState({ commentCreatorVisible: false }) };

    cancelEditMode() { this.setState({ editMode: false }) };

    dateTimeFormat(date) {
        var aaaa = date.getFullYear();
        var gg = date.getDate();
        var mm = (date.getMonth() + 1);

        if (gg < 10)
            gg = "0" + gg;

        if (mm < 10)
            mm = "0" + mm;

        var cur_day = aaaa + "-" + mm + "-" + gg;

        var hours = date.getHours()
        var minutes = date.getMinutes()
        var seconds = date.getSeconds();

        if (hours < 10)
            hours = "0" + hours;

        if (minutes < 10)
            minutes = "0" + minutes;

        if (seconds < 10)
            seconds = "0" + seconds;

        return cur_day + " " + hours + ":" + minutes + ":" + seconds;
    }

    render() {
        const { t, comments, roles, selectComment, selectedComment, centerMap } = this.props;
        const { filterTerm, commentCreatorVisible, deleteButtonDisabled, editMode } = this.state;
        return (
            <StyledWrapper>
                <div
                    style={{
                        position: 'relative',
                        width: '100%',
                    }}>
                    <TextInput
                        style={{
                            width: 'calc(100% - 12px)',
                            margin: '5px',
                        }}
                        type='text'
                        placeholder={t('Search') + '...'}
                        value={filterTerm}
                        onChange={(e) => { this.setState({ filterTerm: e.target.value }) }}>
                    </TextInput>
                    <DefaultButton
                        style={{
                            position: 'absolute',
                            top: '9px',
                            right: '9px',
                        }}
                        visible={this.state.filterTerm !== ''}
                        title={t('Clear')}
                        onClick={() => {
                            this.setState({ filterTerm: '' })
                        }}>
                        <ReactSVG
                            path={IconCancel}
                            style={{
                                fill: '#ffffff',
                                width: '20px',
                                height: '20px'
                            }}
                        />
                    </DefaultButton>
                </div>
                {comments === null
                    ? <Spinner />
                    : <StyledWrapper
                        style={{
                            borderTop: '1px solid rgba(128, 128, 128, 0.1)',
                        }}
                    >
                        {comments
                            .filter(comment => {
                                if (comment.text)
                                    return comment.text.toUpperCase()
                                        .includes(filterTerm.toUpperCase());
                                else return comment.text;
                            })
                            .map(comment => {
                                const commentSelected = selectedComment
                                    ? Number(comment.id) === Number(selectedComment.id)
                                    : false;
                                return (
                                    <ListRow
                                        key={`${comment.id}_comment_row`}>
                                        <input
                                            readOnly
                                            id={`comment_${String(comment.id)}_radio`}
                                            type="radio"
                                            name="comment"
                                            value={comment.id}
                                            checked={commentSelected}
                                            onClick={(e) => {
                                                if (selectedComment && Number(selectedComment.id) === Number(e.target.value))
                                                    selectComment(null);
                                                else
                                                    selectComment(comments.find(comment => Number(comment.id) === Number(e.target.value)));
                                            }} />
                                        <label
                                            htmlFor={`comment_${String(comment.id)}_radio`}
                                            onClick={(e) => {
                                                if (comment.geomWkt) {
                                                    const format = new WKT();
                                                    const feature = format.readFeature(comment.geomWkt)
                                                    const extent = feature.getGeometry().getExtent();
                                                    const center = OlExtent.getCenter(extent);
                                                    centerMap(center);
                                                };
                                            }}>
                                            <div className='rowTitle'>
                                                <div style={{
                                                    whiteSpace: 'normal',
                                                    marginRight: '60px'
                                                }}> {comment.text} </div>
                                                <span> {comment.createdByUserName} {this.dateTimeFormat(new Date(comment.createdDateTime))} </span>
                                                <DefaultButton
                                                    style={{
                                                        position: 'absolute',
                                                        right: '35px',
                                                        top: '5px'
                                                    }}
                                                    type='info'
                                                    visible={commentSelected}
                                                    title={t('Edit')}
                                                    disabled={roles === 'Regular'}
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        e.stopPropagation();
                                                        this.setState({
                                                            editMode: true,
                                                            commentCreatorVisible: true,
                                                        });
                                                        this.props.setEditMode(true);
                                                    }}>
                                                    <ReactSVG
                                                        path={IconEdit}
                                                        style={{
                                                            padding: '2px',
                                                            fill: '#ffffff',
                                                            width: '20px',
                                                            height: '20px',
                                                        }}
                                                    />
                                                </DefaultButton>
                                                <DefaultButton
                                                    style={{
                                                        position: 'absolute',
                                                        right: '5px',
                                                        top: '5px'
                                                    }}
                                                    type='warning'
                                                    visible={commentSelected}
                                                    title={t('Delete')}
                                                    disabled={roles === 'Regular' || deleteButtonDisabled}
                                                    onClick={() => {
                                                        this.customizeModalWindow();
                                                        modalInstance.show();
                                                    }}>
                                                    <ReactSVG
                                                        path={IconDelete}
                                                        style={{
                                                            padding: '2px',
                                                            fill: '#ffffff',
                                                            width: '20px',
                                                            height: '20px',
                                                        }}
                                                    />
                                                </DefaultButton>
                                            </div>
                                        </label>
                                    </ListRow>
                                )
                            })}
                        <DefaultButton
                            style={{
                                position: 'absolute',
                                right: '20px',
                                bottom: '9px',
                                height: '30px',
                                padding: '0 5px',
                            }}
                            disabled={roles === 'Regular'}
                            visible={!commentCreatorVisible}
                            title={t("Add comment")}
                            onClick={() => {
                                this.setState({
                                    commentCreatorVisible: true,
                                });
                                this.props.setEditMode(true);
                                this.props.selectComment(null);
                            }}>
                            {t('Add comment')}
                        </DefaultButton>
                        <CommentCreator
                            comments={comments}
                            visible={commentCreatorVisible}
                            selectedComment={selectedComment}
                            editMode={editMode}
                            cancelEditMode={this.cancelEditMode.bind(this)}
                            hideCommentCreator={this.hideCommentCreator.bind(this)}
                        />
                    </StyledWrapper>
                }
            </StyledWrapper >
        );
    }
}

const mapStateToProps = state => ({
    axiosInstance: state.auth.get('axiosInstance'),
    selectedComment: state.comments.get('selectedComment'),
    comments: state.comments.get('comments'),
    roles: state.auth.get('roles'),
    BASE_URL: state.domainProperties.get('BASE_URL'),
});

const mapDispatchToProps = dispatch => Redux.bindActionCreators({
    getComments,
    getCommentsSuccess,
    selectComment,
    centerMap,
    setEditMode,
}, dispatch);

export default translate("translations")(connect(mapStateToProps, mapDispatchToProps)(CommentsManager));


// WEBPACK FOOTER //
// ./src/containers/content/commentsManager/CommentsManager.jsx